import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { DropdownOptionsService } from '../../../../core/services/dropdown-options.service';
import { BookingService } from '../../services/booking.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SessionBaseComponent } from '../../../../shared/components/session.base.component';

@Component({
  selector: 'laas-booking-header-edit-related-bill',
  templateUrl: './booking-header-edit-related-bill.component.html',
  styleUrls: ['./booking-header-edit-related-bill.component.scss']
})
export class BookingHeaderEditRelatedBillComponent extends SessionBaseComponent implements OnInit {

  formGroup: FormGroup;
  isVisible: boolean;
  @Output() visibleChange = new EventEmitter<any>();

  deliveryCategoryOptions: any[];
  carTypeOptions: any[];
  incoTermOptions: any[];
  expressTermOptions: any[];

  @Input() bookingModel: any;

  constructor(
    injector: Injector,
    private formBuilder: FormBuilder,
    private dropdownOptionService: DropdownOptionsService,
    private bookingService: BookingService
  ) {
    super(injector);

    this.formGroup = this.formBuilder.group({
      deliveryType: null,
      carType: null,
      incoTerm: null,
      expressTerm: null,
      updatedTotalCaseCnt: null,
      updatedTotalGrosswgt: null,
      updatedTotalVolumeWeight: null
    });

    this.isVisible = false;

    this.deliveryCategoryOptions = [];
    this.carTypeOptions = [];
    this.incoTermOptions = [];
    this.expressTermOptions = [];

    this.bookingModel = {};
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionService.getDeliveryTypeOptions(false)
        .subscribe({
          next: (options: any[]) => {
            this.deliveryCategoryOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
          }
        });

    this.dropdownOptionService.getIncoTermOptions()
      .subscribe({
        next: (options: any[]) => {
          this.incoTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionService.findFacilityOptionsByOptionType('ExpressTerm')
      .subscribe({
        next: (options: any[]) => {
          this.expressTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
  }

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
  }

  dialogVisibleChange(value: boolean): void {
    this.visibleChange.emit(value);
  }

  changeIncoTerm(event: any): void {
    if (!event.value) {
      this.formGroup.controls.incoTerm.setValue('');
    }
  }

  changeExpressTerm(event: any): void {
    if (!event.value) {
      this.formGroup.controls.expressTerm.setValue('');
    }
  }

  saveRelatedBill(event: any): void {
    let location = '';
    if (this.bookingModel.shipTerm) {
      const firstCode = this.bookingModel.shipTerm.substr(0, 1);
      const thirdCode = this.bookingModel.shipTerm.substr(3, 1);
      let afterThirdCode = this.bookingModel.shipTerm.substr(3);
      if (firstCode === '_') {
        location += this.bookingModel.shipTerm;
      } else if (thirdCode === '-' || thirdCode === '_') {
        location += afterThirdCode;
      } else {
        afterThirdCode = afterThirdCode.indexOf(')') > -1 ? afterThirdCode.substr(afterThirdCode.indexOf(')') + 1) : afterThirdCode;
        if (afterThirdCode.indexOf('-') > -1) {
          location += afterThirdCode.substr(afterThirdCode.indexOf('-'));
        } else if (afterThirdCode.indexOf('_') > -1) {
          location += afterThirdCode.substr(afterThirdCode.indexOf('_'));
        }
      }
    }

    const requestParam = {
      bookingNo: this.bookingModel.bookingNo,
      updateUser: this.userProfile.userName,
      deliveryType: this.formGroup.value.deliveryType,
      carType: this.formGroup.value.carType,
      incoTerm: this.formGroup.value.incoTerm,
      shipTerm: this.formGroup.value.incoTerm + location,
      expressTerm: this.formGroup.value.expressTerm,
      updatedTotalCaseCnt: this.formGroup.value.updatedTotalCaseCnt,
      updatedTotalGrosswgt: this.formGroup.value.updatedTotalGrosswgt,
      updatedTotalVolumeWeight: this.formGroup.value.updatedTotalVolumeWeight
    };

    this.bookingService.updateBookingRelatedBilling(requestParam).subscribe({
      next: result => {
        this.translateService.get('Common.Message.SuccessSave').subscribe({
          next: msg => {
            this.toastService.success(msg);
            this.dialogVisibleChange(false);
          }
        });
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.dialogVisibleChange(false);
      }
    });
  }
}
